export default "__VITE_ASSET__BYxEVRQi__"